import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

export default function useSlashInactiveAlert(slashInactiveMessage) {
  const messageRef = useRef(slashInactiveMessage)
  const isActive = useSelector(state => state.landing.isActive)
  const [alertShown, setAlertShown] = useState(false)

  useEffect(() => {
    if (!alertShown && !isActive) {
      setAlertShown(true)
      alert(messageRef.current)
    }
  }, [isActive, alertShown, setAlertShown])
}
